<template>
  <el-card>
    <el-row :gutter="12">
      <el-col>
        <el-divider content-position="left">活动日期: {{ upgradeInfo.beginDate }}至{{ upgradeInfo.endDate }}</el-divider>
      </el-col>
      <el-col>
        <span style="font-size: 12px" v-if="data.level_id === 4">
          1、总代3个部门，每个部门完成{{ upgradeInfo.toLianchuan }}盒（报单与复销），完成直推20个会员可升级联创
          <br />
          2、满足条件后，升级操作在次日凌晨执行
          <br />
        </span>
        <span style="font-size: 12px" v-if="data.level_id <= 3">
          温馨提示
          <br />
          VIP代理：复销{{ upgradeInfo.toYiji }}盒产品可晋级为一级代理.
          <br />
          一级代理：复销{{ upgradeInfo.toGuanfang }}盒产品可晋级为官方代理.
          <br />
          官方代理：复销{{ upgradeInfo.toZongdai }}盒产品可晋级为总代.
          <br />
        </span>
      </el-col>

      <el-col>
        <el-table style="width: 100%" :data="upgradeDetail" v-if="data.level_id <= 3">
          <el-table-column type="index" width="50" />
          <el-table-column prop="level_name" label="等级">
            <template slot-scope="scope">
              <span
                :style="scope.row.status === 2 || level_id >= scope.row.level_id ? 'color: #ccc;text-decoration-line: line-through;' : ''"
                >{{ scope.row.level_name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="requireNum" label="需要数量">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status === 2 || level_id >= scope.row.level_id" style="color: #ccc;">--</span>
              <span v-else>{{ scope.row.requireNum }}</span> -->
              <span v-if="scope.row.status === 2 || level_id >= scope.row.level_id" style="color: #ccc">{{ scope.row.requireNum }}</span>
              <span v-else>{{ scope.row.requireNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stillNeedNum" label="当前情况">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 2 || level_id >= scope.row.level_id" style="color: #ccc">已完成</span>
              <span v-else>
                还需
                <span style="color: green">{{ scope.row.stillNeedNum }}</span>
                盒
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-table style="width: 100%" :data="upgradeDetail" v-if="data.level_id === 4">
          <el-table-column type="index" width="50" />
          <el-table-column label="代理">
            <template slot-scope="scope">
              <span>{{ scope.row.real_name }}/{{ scope.row.level_name }}</span>
              <br />
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成量">
            <template slot-scope="scope">
              <span>{{ scope.row.team_complete_num }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成情况">
            <template slot-scope="scope">
              <span v-if="scope.row.status">完成</span>
              <span v-else style="color: red">待完成</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <br />
    </el-row>
  </el-card>
</template>

<script>
import { getUpgradeActivity } from '@/api/users'
export default {
  name: 'UserDetailUpgradeActivity',
  components: {},
  props: {
    data: Object,
  },
  data() {
    return {
      level_id: 0,
      upgradeInfo: {},
      upgradeDetail: [],
    }
  },
  computed: {},
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const id = this.$route.params['id']
      const { data } = await getUpgradeActivity(id, {})
      console.log(data)
      this.level_id = data.level_id
      this.upgradeInfo = data.upgrade_config
      this.upgradeDetail = data.detail

      console.log('level_id', this.level_id)
    },
  },
}
</script>

<style></style>
